var $afa6d5819988437d$exports = {};
$afa6d5819988437d$exports = {
    "backButton": (args)=>`\xc5terg\xe5 till ${args.prevMenuButton}`,
    "moreActions": `Fler \xe5tg\xe4rder`,
    "unavailable": `Ej tillg\xe4nglig, expandera f\xf6r mer information`
};


export {$afa6d5819988437d$exports as default};
//# sourceMappingURL=sv-SE.module.js.map
